export const ProjectsPage = () => {
  return (
    <>
      <h1>ProjectsPage</h1>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          flex: 1,
          height: 200,
        }}
      >
        <div
          className="glass"
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            flex: 1,
            width: 200,
          }}
        >
          <a>Hello</a>
        </div>
      </div>
    </>
  );
};
